const normalizeFontSizeValue = (value) => {
  if (typeof value !== 'string') return '';

  const normalized = value.trim();
  return normalized || '';
};

export const getContentFontStyle = (value, fallback = null) => {
  const resolved = normalizeFontSizeValue(value) || normalizeFontSizeValue(fallback);
  return resolved ? { fontSize: resolved } : undefined;
};

export const getHeadingFontStyle = (value, level, fallbackByLevel = {}) => {
  const fallback = fallbackByLevel[level] ?? fallbackByLevel.default ?? null;
  return getContentFontStyle(value, fallback);
};